import React from "react"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import styled from "styled-components"
import {Firebase} from "../../components/Firebase"
import {Layout} from "../../projects/costProjection/components/Layout"
import {ReportFooter} from "../../projects/costProjection/components/ReportFooter"
import {ReportContainer} from "../../projects/costProjection/containers/ReportContainer"
import headerLinks from "../../projects/costProjection/data/headerLinks.json"

class Report extends React.Component {
  componentDidMount() {
    this.firebase = new Firebase()
  }

  render() {
    return (
      <Layout headerLinks={headerLinks} footerRenderer={() => <ReportFooter />}>
        <OuterDiv>
          <ReportContainer/>
        </OuterDiv>
      </Layout>
    )
  }
}

const OuterDiv = styled.div`
  margin-bottom: ${(props) => props.theme.gutter / 2}px;
`

const createSelectors = createStructuredSelector({
})

export default connect(createSelectors, {})(Report)
